module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.19798/images/empty-folder.svg"